/* istanbul ignore file */
import { LandingPageRoutes } from 'src/modules/LandingPages';
import { AsyncRouteProps } from 'src/components/AsyncRoute/AsyncRoute';
import { SubscriptionsRoutes } from 'src/modules/Subscriptions/routes';
import { Environment } from 'src/environment';

export type RouteConfig = { [key: string]: AsyncRouteProps };

const errorPageRouteProps: AsyncRouteProps = {
  module: () => import('../components/ErrorPage/index'),
  export: 'ErrorPage',
};

const settingsPageRouteProps: AsyncRouteProps = {
  module: () => import('../modules/Auth/index'),
  export: 'SignIn',
};

const baseRoutes: RouteConfig = Object.assign(
  SubscriptionsRoutes,
  LandingPageRoutes,
  {
    '/modules/privacy/page': {
      module: () => import('../modules/Privacy'),
      export: 'Privacy',
    },
    '/help/privacy': {
      module: () => import('../modules/Privacy'),
      export: 'Privacy',
    },
    '/settings': settingsPageRouteProps,
    '/login': {
      module: () => import('../modules/Auth/index'),
      export: 'SignIn',
    },
    '/:anything': errorPageRouteProps,
    '/': settingsPageRouteProps,
  },
);

export function getRoutes(appConfig: AppConfig): RouteConfig {
  const { environment } = appConfig;
  const routes = { ...baseRoutes };
  if (environment === Environment.PROD) {
    routes['/'] = errorPageRouteProps;
    delete routes['/login'];
    delete routes['/settings'];
  }
  return routes;
}
